import { browserHistory } from "react-router";
import {confirm} from 'util/confirm'
import {alert} from 'util/alert'
import removeStudentFromClass from 'controllers/class/removeStudentFromClass'
import {fetchClassStudent} from './ducks'
import PaymentModal, { REFUND } from 'template/Modals/NewPayment';

import StudentInfoDock from 'template/Docks/StudentInfo';
import { userCan } from 'containers/__R';

export default function getDefaultTableSettings() {
  let TabComponent = this;
  let {dispatch} = this.props
  const classId = this.props.params.classId

	return [
    {
      title: __('Student Detail', 'classdetail'),
      onClick: ({trData: studentInfo})=>{
        const {schoolStudentID} = studentInfo
        StudentInfoDock({ id: schoolStudentID })
          .then(res=>{
            if(res.isUpdated) {
              dispatch(fetchClassStudent(classId))
            }
          });
      },
      isDisabled: () => {
        return !userCan('read_class_student');
      }
    },
    {
      title: __('Exit Class', 'classdetail'),
      onClick: ({trData: student}) => {
        if(student.paidInFee > 0){
          confirm(__('This student has paid tuition, do you wish to refund?', 'studentTable'))
          .then(() => {
            let classDetail = this.props.classDetail.detail;
            let { user_id } = this.props.user.result;
            let student_name = student.schoolStudentName;

            PaymentModal({
              student,
              classDetail,
              user_id,
              paymentType: REFUND,
              confirmTitle: __('Refund & Exit Class', 'classdetail'),
              confirmText: __('Proceed to refund and remove the student, {student_name}, from class?', 'classdetail', { student_name }),
            })
            .then(()=>{
              // STEP 2. use controller to call backend
              removeStudentFromClass(Number(classId), Number(student.schoolStudentID))
              .then((res)=>{
                alert.success(__('The student {student_name} has been removed from the class.', 'student', { student_name }), __('Exit Class Successful', 'student')).then(()=>{
                  dispatch(fetchClassStudent(Number(classId)))
                });;
              })
              .catch((err)=>{
                console.error(err);
              });

            });
          })
          .catch(() => {
            const {schoolStudentName} = student
            confirm(__('Exit Student: {name} From Class?', 'classdetail', {name: schoolStudentName }))
            .then(() => {
              removeStudentFromClass(Number(classId), Number(student.schoolStudentID))
              .then((res) => { dispatch(fetchClassStudent(classId)) })
            })
            .catch(() => {})
          })
        } else {
          const {schoolStudentName} = student
          confirm(__('Exit Student: {name} From Class?', 'classdetail', {name: schoolStudentName }))
          .then(() => {
            removeStudentFromClass(Number(classId), Number(student.schoolStudentID))
            .then((res) => { dispatch(fetchClassStudent(classId)) })
          })
          .catch(()=>{})
        }
      },
      isDisabled: ({trData: studentInfo}) => {
        return (studentInfo.classStudentState == 0 || !userCan('archive_student_from_class'))
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/StudentTable/table-settings.js